module.exports = __webpack_public_path__ + "static/nycaloth-d4779e5324b798c99c79aa44a3413ed5.jpeg";